var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75312 11.7187C10.0459 12.0115 10.0459 12.4866 9.75312 12.7794C9.46034 13.0722 8.9853 13.0722 8.69249 12.7794L4.99999 9.05937L1.28124 12.7781C0.988461 13.0709 0.51343 13.0709 0.220617 12.7781C-0.0721953 12.4853 -0.0721641 12.0103 0.220617 11.7175L3.94062 8L0.219586 4.25312C-0.0731953 3.96034 -0.0731953 3.48531 0.219586 3.1925C0.512367 2.89969 0.987399 2.89972 1.28021 3.1925L4.99999 6.94062L8.71874 3.22187C9.01152 2.92909 9.48656 2.92909 9.77937 3.22187C10.0722 3.51465 10.0721 3.98969 9.77937 4.2825L6.05937 8L9.75312 11.7187Z",
    fill: "#7A7A7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.99a8d39a250ba716c340b02f81c9c63a.svg";
export { ForwardRef as ReactComponent };